import { Grid, Typography } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import MuiListNativeStyled from "../List/MuiListNativeStyled";

const PrivacyPolicyUpdateDetails = () => {
  return (
    <Grid container rowSpacing={2} sx={{ padding: "20px 0px" }}>
      <Grid item>
        <Typography>
          Wir haben unsere Datenschutzerklärung aktualisiert, um Ihnen noch mehr Transparenz über die Verarbeitung Ihrer personenbezogenen Daten zu bieten.
          Die Änderungen treten am 19.06.2025 in Kraft.
        </Typography>
      </Grid>
      <Grid item>
        <MuiListNativeStyled
          listItems={[
            <>
              <strong>Einsatz von KI zur Unterstützung der Mandatsbearbeitung:</strong>
              <br />
              Wir nutzen KI-gestützte Technologien um die Qualität unserer anwaltlichen Dienstleistungen zu verbessern. Die Verarbeitung erfolgt auf Grundlage
              unseres berechtigten Interesses an einer modernen, effizienten und qualitativ hochwertigen Mandatsbearbeitung gemäß DSGVO.
            </>,
          ]}
        />
      </Grid>
      <Grid item>
        <MuiListNativeStyled
          listItems={[
            <>
              <strong>Klarstellung zur Gesprächsaufzeichnung und Zusammenfassung:</strong>
              <br />
              Sofern Sie eingewilligt haben, können Beratungsgespräche zu Dokumentationszwecken aufgezeichnet und anschließend zusammengefasst werden. Sie
              können Ihre Einwilligung jederzeit widerrufen
            </>,
          ]}
        />
      </Grid>
      <Grid item>
        <MuiListNativeStyled
          listItems={[
            <>
              <strong>Datenübermittlung und Schutzmaßnahmen:</strong>
              <br />
              Falls wir Daten in andere Länder übermitteln müssen, stellen wir sicher, dass dies immer im Einklang mit den gesetzlichen Vorgaben der DSGVO
              erfolgt. Wir nutzen dabei Schutzmaßnahmen wie Standardvertragsklauseln, um die Sicherheit Ihrer Daten zu gewährleisten.
            </>,
          ]}
        />
      </Grid>
      <Grid item>
        <Typography>
          Sie können die aktuelle Datenschutzerklärung jederzeit{" "}
          <Link target={"_blank"} to={"/datenschutz"}>
            hier
          </Link>{" "}
          einsehen.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PrivacyPolicyUpdateDetails;
